import { render } from "./RoomBookingSummary.vue?vue&type=template&id=02b31660"
import script from "./RoomBookingSummary.vue?vue&type=script&lang=js"
export * from "./RoomBookingSummary.vue?vue&type=script&lang=js"

import "@/modules/stay/css/components/room-booking-summary.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__